export default __webpack_public_path__ + "static/media/road-map-top.97fc93f9.png";